import NewStaffMemberFormModal from './NewStaffMemberFormModal.container';

export default NewStaffMemberFormModal;
